// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__232ef","disabled":"styles_disabled__3CjRy"};